export const CSS_CLASSES = {
  TEXT_AREA_ROOT: "text-area-root",
  TEXT_AREA_ROOT_DISABLED: "text-area-root-disabled",
  TEXT_AREA_ROOT_SUCCESS: "text-area-root-success",
  TEXT_AREA_ROOT_ERROR: "text-area-root-error",
  TEXT_AREA_ROOT_TEXT_ALIGN_LEFT: "text-area-root-text-align-left",
  TEXT_AREA_ROOT_TEXT_ALIGN_CENTER: "text-area-root-text-align-center",
  TEXT_AREA_ROOT_TEXT_ALIGN_RIGHT: "text-area-root-text-align-right",
  TEXT_AREA_ELEMENT: "text-area-element",
};
